module.exports = __webpack_public_path__ + "img/instagram.56eb0b3a.svg";